import React from "react";
import { RiArrowRightUpLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import samsung from "../../assets/product-catagories/samsung.png";
import xiaomi from "../../assets/product-catagories/xiaomi.png";
import littman from "../../assets/product-catagories/littman.png";
import mdm from "../../assets/product-catagories/mdm.png";
import dualRhythm from "../../assets/product-catagories/dual-rhythm.png";
import penTorch from "../../assets/product-catagories/pen-torch.jpg";
import repairKit from "../../assets/product-catagories/steth-repair-kit.jpg";
import stethCase from "../../assets/product-catagories/steth-case.jpg";
import tempGlass from "../../assets/product-catagories/temp.jpg";
import tabPen from "../../assets/product-catagories/tab-pen.jpg";
import tabCase from "../../assets/product-catagories/tab-case.jpg";
import kneeHammer from "../../assets/product-catagories/knee-hammer.jpg";
import SubCategoryCard from "./SubCatagoryCard";
import HeaderTitle from "../headerTitle/HeaderTitle";

const ProductCategories = ({ setSearch }) => {
  return (
    <section className="flex flex-col items-center justify-center w-full bg-white py-8">
      <div className="w-full max-w-screen-lg px-4 lg:px-0">
        <HeaderTitle title="Product Categories" />

        <div className="bg-_white rounded-lg  grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 p-6 lg:p-8 gap-8 my-8 mx-2 lg:mx-0">
          {/* TABLETS SECTION */}
          <div
            className="flex flex-col gap-4 items-start md:col-span-2 lg:col-span-1"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-_blue mb-2">
              Tablets
            </h2>
            <p className="text-_gray text-sm md:text-base leading-relaxed">
              Explore our range of premium tablets, designed for exceptional performance and professional use.
            </p>
            <Link to="/store/tabs" className="mt-4">
              <button className="flex items-center justify-center bg-_blue hover:bg-opacity-90 transition-all duration-300 px-4 md:px-5 py-2 md:py-2.5 gap-2 rounded-md text-_white">
                <span className="font-medium">View Collection</span>
                <RiArrowRightUpLine className="text-lg" />
              </button>
            </Link>
          </div>

          <SubCategoryCard
            placeholderImg={samsung}
            title="Samsung"
            paragraph="Premium tablets with high-resolution displays and enterprise-grade performance."
            path="/store/tabs"
            setSearch={setSearch}
            searchTxt={"samsung"}
          />

          <SubCategoryCard
            placeholderImg={xiaomi}
            title="Xiaomi"
            paragraph="Feature-rich tablets offering exceptional value with advanced technology."
            path="/store/tabs"
            setSearch={setSearch}
            searchTxt={"xiaomi"}
          />

          <hr className="w-full h-0.5 bg-_gray_lite col-span-1 md:col-span-2 lg:col-span-3 my-8 md:my-12" />

          {/* TABLET ACCESSORIES SECTION */}
          <div
            className="col-span-1 md:col-span-2 lg:col-span-3 flex flex-col items-start justify-center pt-4 md:pt-8 pb-4 gap-4"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div
              className="flex flex-col gap-4 items-start w-full md:w-2/3 lg:w-1/2"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-_blue mb-2">
                Tablet Accessories
              </h2>
              <p className="text-_gray text-sm md:text-base leading-relaxed">
                Enhance productivity and device longevity with our premium accessories designed for professional environments.
              </p>
              <Link to="/store/tab-accessories" className="mt-4">
                <button className="flex items-center justify-center bg-_blue hover:bg-opacity-90 transition-all duration-300 px-4 md:px-5 py-2 md:py-2.5 gap-2 rounded-md text-_white">
                  <span className="font-medium">View Collection</span>
                  <RiArrowRightUpLine className="text-lg" />
                </button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full mt-6 md:mt-8">
              <SubCategoryCard
                placeholderImg={tempGlass}
                title="Tempered Glass"
                paragraph="Medical-grade screen protectors providing crystal clear visibility and optimal protection."
                path="/store/tab-accessories"
              />

              <SubCategoryCard
                placeholderImg={tabPen}
                title="Stylus Pens"
                paragraph="Precision instruments for digital note-taking and medical document annotation."
                path="/store/tab-accessories"
              />

              <SubCategoryCard
                placeholderImg={tabCase}
                title="Cases & Pouches"
                paragraph="Durable protection solutions designed for healthcare environments."
                path="/store/tab-accessories"
              />
            </div>
          </div>

          <hr className="w-full h-0.5 bg-_gray_lite col-span-1 md:col-span-2 lg:col-span-3 my-8 md:my-12" />

          {/* STETHOSCOPE SECTION */}
          <div
            className="col-span-1 md:col-span-2 lg:col-span-3 flex flex-col items-start justify-center pt-4 md:pt-8 pb-4 gap-4"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div className="flex flex-col gap-4 items-start w-full md:w-2/3 lg:w-1/2">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-_blue mb-2">
                Stethoscopes
              </h2>
              <p className="text-_gray text-sm md:text-base leading-relaxed">
                Elevate your diagnostic capabilities with industry-leading stethoscopes engineered for acoustic clarity and clinical precision.
              </p>
              <Link to="/store/steth-accessories" className="mt-4 mb-6 md:mb-8">
                <button className="flex items-center justify-center bg-_blue hover:bg-opacity-90 transition-all duration-300 px-4 md:px-5 py-2 md:py-2.5 gap-2 rounded-md text-_white">
                  <span className="font-medium">View Collection</span>
                  <RiArrowRightUpLine className="text-lg" />
                </button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
              <SubCategoryCard
                placeholderImg={littman}
                title="Littmann"
                paragraph="Gold standard in auscultation with superior acoustic performance and reliability."
                path="/store/steth-accessories"
                setSearch={setSearch}
                searchTxt={"littmann stethoscope"}
              />

              <SubCategoryCard
                placeholderImg={mdm}
                title="MDF"
                paragraph="Professional diagnostic instruments with lifetime warranty and precision engineering."
                path="/store/steth-accessories"
                setSearch={setSearch}
                searchTxt={"MDF stethoscope"}
              />

              <SubCategoryCard
                placeholderImg={dualRhythm}
                title="Dual Rhythm"
                paragraph="Advanced acoustic technology for enhanced cardiovascular and pulmonary assessment."
                path="/store/steth-accessories"
                setSearch={setSearch}
                searchTxt={"Dual Rhythm stethoscope"}
              />
            </div>
          </div>

          {/* STETHOSCOPE ACCESSORIES SECTION */}
          <div
            className="col-span-1 md:col-span-2 lg:col-span-3 flex flex-col items-start justify-center pt-4 md:pt-8 pb-4 gap-4"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div className="flex flex-col gap-4 items-start w-full md:w-2/3 lg:w-1/2">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-_blue mb-2">
                Stethoscope Accessories
              </h2>
              <p className="text-_gray text-sm md:text-base leading-relaxed">
                Maintain and enhance your diagnostic equipment with professional accessories designed for healthcare practitioners.
              </p>
              <Link to="/store/steth-accessories" className="mt-4 mb-6 md:mb-8">
                <button className="flex items-center justify-center bg-_blue hover:bg-opacity-90 transition-all duration-300 px-4 md:px-5 py-2 md:py-2.5 gap-2 rounded-md text-_white">
                  <span className="font-medium">View Collection</span>
                  <RiArrowRightUpLine className="text-lg" />
                </button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
              <SubCategoryCard
                placeholderImg={penTorch}
                title="Pen Torches"
                paragraph="Medical-grade diagnostic lighting tools with precision illumination."
                path="/store/steth-accessories"
              />

              <SubCategoryCard
                placeholderImg={stethCase}
                title="Stethoscope Cases"
                paragraph="Protective storage solutions designed for medical professionals on the move."
                path="/store/steth-accessories"
              />

              <SubCategoryCard
                placeholderImg={repairKit}
                title="Repair Kits"
                paragraph="Professional maintenance tools to ensure optimal stethoscope performance and longevity."
                path="/store/steth-accessories"
              />
              <SubCategoryCard
                placeholderImg={kneeHammer}
                title="Knee hammer"
                paragraph="Precision diagnostic tool used by medical professionals for neurological assessments"
                path="/store/steth-accessories"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;